import React from 'react';
import TALoginPage from '../pageComponents/TALoginPage/TALoginPage';
import { withBreakpoints } from '../components/Boneyard';
import SiteLayout from '../components/SiteLayout';
import colors from '../theme/theme/colors.common.js';

function TaLogin() {
  return (
    <SiteLayout
      title="Login Page"
      hideNavOptions
      hideStadiumBanner
      backgroundColor={colors.taBackground}
    >
      <TALoginPage />
    </SiteLayout>
  );
}

export default withBreakpoints(TaLogin);
